export default function EFPile() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.66667 9.16666C6.66667 7.78595 7.78595 6.66666 9.16667 6.66666H20.8333C22.214 6.66666 23.3333 7.78594 23.3333 9.16666V22.0833H25C26.6108 22.0833 27.9167 23.3892 27.9167 25V28.3333C27.9167 29.4839 28.8494 30.4167 30 30.4167C31.1506 30.4167 32.0833 29.4839 32.0833 28.3333V20H30V13.3333H32.0833V8.33332H34.5833V13.3333H36.6667V20H34.5833V28.3333C34.5833 30.8646 32.5313 32.9167 30 32.9167C27.4687 32.9167 25.4167 30.8646 25.4167 28.3333V25C25.4167 24.7699 25.2301 24.5833 25 24.5833H23.3333V31.6667H25V35H5V31.6667H6.66667V9.16666ZM10.8334 20H13.6112L12.5 26.6667H13.0129L19.1667 20H16.3889L17.5 13.3333H16.9872L10.8334 20Z"
                fill="#69BAF2"
            />
        </svg>
    );
}
